import { AiOutlineUser } from "react-icons/ai";
import { CiDollar } from "react-icons/ci";
import { IoIosClose } from "react-icons/io";
import { MoonLoader } from "react-spinners";
import { useModalEditRuta } from "./modalEditRutaHooks";
import type { ModalEditRutaProps } from "./types";

export const ModalEditRuta = (props: ModalEditRutaProps) => {
  const modalState = useModalEditRuta(props);

  if (!modalState) {
    return null;
  }

  const {
    canSubmit,
    editarRuta,
    handleClose,
    handleFieldChange,
    handleOperacionChange,
    isEditing,
    responsable,
    sumaResta,
  } = modalState;

  return (
    <div className="w-full min-h-screen h-screen z-20 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
      <div className="bg-gray-200 w-[400px] p-4 rounded-md relative max-h-[90%] overflow-y-auto text-sm">
        <IoIosClose
          className="absolute right-0 top-0 cursor-pointer"
          size={40}
          onClick={handleClose}
        />

        <h2 className="text-center text-xl font-semibold">Editar Ruta</h2>
        <form className="w-full mt-2">
          <div className="w-full flex flex-col gap-2 items-center">
            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                <AiOutlineUser size={24} />
              </div>
              <input
                type="text"
                className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder="Nombre del responsable"
                value={responsable}
                onChange={handleFieldChange("responsable")}
                required
              />
            </div>
            <div className="flex w-full h-[40px] border border-gray-400 rounded-md">
              <div className="h-full w-[40px] bg-gray-200 flex items-center justify-center rounded-l-md border-r border-gray-400">
                <CiDollar size={24} />
              </div>
              <input
                type="number"
                className="flex-1 rounded-md w-full px-2 focus:border-transparent focus:outline-none"
                placeholder="Ingresar valor"
                onChange={handleFieldChange("valor")}
                required
              />
            </div>
            <div className="w-full flex justify-around">
              <button
                className={`bg-green-600 text-base font-semibold mt-2 w-fit text-white py-[2px] rounded-md flex justify-center items-center min-w-[80px] ${
                  sumaResta === "sumar" ? "bg-green-900" : ""
                }`}
                onClick={() => handleOperacionChange("sumar")}
                type="button"
              >
                Sumar
              </button>
              <button
                type="button"
                className={`bg-red-600 text-base font-semibold mt-2 w-fit text-white py-[2px] rounded-md flex justify-center items-center min-w-[80px] ${
                  sumaResta === "restar" ? "bg-red-900" : ""
                }`}
                onClick={() => handleOperacionChange("restar")}
              >
                Restar
              </button>
            </div>
            <div className="mt-2 flex justify-between w-full">
              <button
                type="button"
                className="bg-[#8131bd] text-lg font-semibold mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
                onClick={editarRuta}
                disabled={isEditing || !canSubmit}
              >
                {isEditing ? <MoonLoader size={20} color="#ffffff" /> : "Editar"}
              </button>

              <button
                type="button"
                className="bg-gray-500 text-lg font-semibold mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
                onClick={handleClose}
                disabled={isEditing}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
